import { Box, FormControl, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { AffiliateNetworkConfig, CIQConfig, MerchantAffiliateNetwork } from "src/types/merchants"
import { encryptWithPubkey } from "src/utils/rsa"

interface CIQInputFormProps {
  handleAffiliateNetworkConfigChange: (newConfig: AffiliateNetworkConfig) => void
  existingConfig: AffiliateNetworkConfig
}

const CIQInputForm: React.FC<CIQInputFormProps> = ({handleAffiliateNetworkConfigChange, existingConfig}) => {
  const [apiKey, setApiKey] = useState('')
  const [encryptedApiKey, setEncryptedApiKey] = useState('')
  const [campaignId, setCampaignId] = useState(existingConfig.ciq?.campaignId)
  const [partnerId, setPartnerId] = useState(existingConfig.ciq?.partnerId)

  // encrypt the api key as the user makes changes to it
  useEffect(() => {
    if (!apiKey) {
      setEncryptedApiKey('')// no need to encrypt an empty string
    }  else {
      setEncryptedApiKey(encryptWithPubkey(apiKey))
    }
  },[apiKey])

  // set the new state in the merchant object
  useEffect(() => {
    const newConfig = {
      type: MerchantAffiliateNetwork.CIQ,
      ciq: {
        apiKey: {
          transportEncrypted: encryptedApiKey,
        },
        campaignId: campaignId,
        partnerId: partnerId
      } as CIQConfig
    }

    handleAffiliateNetworkConfigChange(newConfig)
  },[encryptedApiKey, campaignId, partnerId, handleAffiliateNetworkConfigChange])

  return (
    <Box>
      <FormControl className="formControlsContainer">
        <TextField
          value={apiKey}
          onChange={(e) => {
            setApiKey(e.target.value)
          }}
          label='CIQ API Key'
          variant="outlined"
        />
      </FormControl>
      <FormControl className="formControlsContainer">
          <TextField
            value={campaignId}
            onChange={(e) => {
              setCampaignId(e.target.value)
            }}
            label='CIQ Campaign ID'
            variant="outlined"
          />
        </FormControl>
        <FormControl className="formControlsContainer">
          <TextField
            value={partnerId}
            onChange={(e) => {
              setPartnerId(e.target.value)
            }}
            label={`Merchant's CIQ Partner ID`}
            variant="outlined"
          />
        </FormControl>
    </Box>
  )
}

export default CIQInputForm